import { useCssHandles } from '../../../utils/functions';
import './global.css';

const SIMULATE_SHIPPING_CSS_HANDLES = [
	'simulateShipping',
	'simulateShippingSearch',
	'simulateShippingSpinner',
] as const;

function SimulateShipping({ componentId, blockClass }: any) {
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SIMULATE_SHIPPING_CSS_HANDLES, blockClass);

	return (
		<div
			data-selection={componentId}
			className={`${handles.simulateShipping} mt7 flex mr-auto ml-auto mw6 ba-s b--muted-3 pl4 pv5 pb5 mb3 br2`}
		>
			<form className="vtex-address-form__postalCode vtex-address-form__field--small  pb7">
				<label className="vtex-input w-100">
					<span className="vtex-input__label db mb3 w-100 c-on-base t-small ">CEP</span>
					<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
						<input
							className="vtex-address-form-4-x-input ma0 border-box vtex-address-form-4-x-hideDecorators vtex-address-form-4-x-noAppearance br2  br-0 br--left  w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body pl5 "
							name="postalCode"
							type="tel"
							value=""
						/>
						<span className="c-muted-2 fw5 flex items-center t-body bg-base  vtex-input__suffix br2 bl-0 br--right pr5 pl3 "></span>
					</div>
				</label>
				<div className="vtex-address-form__postalCode-forgottenURL pt4 flex-none">
					<a
						href="//buscacepinter.correios.com.br/app/endereco/index.php?t"
						target="_blank"
						className="pointer c-link hover-c-link active-c-link no-underline underline-hover "
						rel="noopener noreferrer"
					>
						Não sei meu CEP
						<span className="ml2">
							<svg
								className="vtex__icon-external-link  "
								width="12"
								height="12"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 16 16"
								fill="none"
							>
								<path
									d="M8.7 0H1.7V2H6.3L1.90735e-07 8.3L1.4 9.7L7.7 3.4V8H9.7V1C9.7 0.4 9.3 0 8.7 0Z"
									transform="translate(6.30005)"
									fill="currentColor"
								></path>
								<path
									d="M14 15H1C0.4 15 0 14.6 0 14V1C0 0.4 0.4 0 1 0H5V2H2V13H13V10H15V14C15 14.6 14.6 15 14 15Z"
									transform="translate(0 1)"
									fill="currentColor"
								></path>
							</svg>
						</span>
					</a>
				</div>
			</form>
			<button
				className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-small t-action--small bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer w-100 "
				type="submit"
			>
				<div
					className="vtex-button__label flex items-center justify-center h-100 ph5 w-100 border-box "
					style={{ paddingTop: '.25em', paddingBottom: '.32em' }}
				>
					Calcular o frete
				</div>
			</button>
		</div>
	);
}

export default SimulateShipping;
